<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" lg="6">
        <v-card elevation="3" rounded="lg" class="pa-6 text-center">

          <v-icon size="64" color="warning">
            mdi-alert-circle-outline
          </v-icon>

          <h1 class="text-h5 font-weight-light mt-4 mb-3">
            Não foi possível concluir sua solicitação no momento.
            Entre em contato com nossa central para continuar o atendimento.
          </h1>

          

          <v-divider class="mb-6"></v-divider>

          <v-card
  outlined
  class="pa-6 text-center"
  style="border-radius: 12px;"
>
  <div
    class="text-overline grey--text text--darken-1 mb-4"
    style="letter-spacing: 3px;"
  >
    CENTRAL DE ATENDIMENTO
  </div>

  <div class="text-h4 font-weight-bold primary--text mb-5" >
   <a href="tel:22064883">  {{ telefone }} </a>
  </div>

  <div class="grey--text text--darken-1 mb-3">
    Escolha um dos canais abaixo:
  </div>

  <div class="d-flex justify-center align-center">
    <a
      href="https://esycb.me/SITE"
      target="_blank"
      class="mx-4"
    >
      <img
        src="@/assets/login/whatsapp_ti.png"
        width="42"
        title="WhatsApp"
      />
    </a>

    <a
      href="https://t.me/Easycob_bot"
      target="_blank"
      class="mx-4"
    >
      <img
        src="@/assets/login/telegram_ti.png"
        width="42"
        title="Telegram"
      />
    </a>
  </div>
</v-card>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ErroPage",
  data() {
    return {
      telefone: "(21) 2206- 4883",
    };
  },
  async mounted() {
    await this.$store.dispatch("setMostraBotoes", {
      imprimir: false,
      voltar: false,
    });
    /*
    if (this.$store.state.credor_atual == "DI SANTINNI DSCARD") {
      this.telefone = "(21) 2206- 4886";
    } */
  },
};
</script>